import {
    CardSharesApi,
    CardsApi,
    CustomerPaymentsApi,
    IBANApi,
    OrdersApi,
    TransactionsApi,
    PaymentsApi,
} from '@/api/general';
import { CommonTermsApi } from '@/api/dictionary';
import { WebhookApi } from '@/api/webhook';
import { ConfigApi } from '@/api/client/api/config-api';
import { ClientAPIKeyApi, UsersApi, RolesApi } from '@/api/client';
import { OnboardingApi } from '@/api/client/api/onboarding-api';

export const cardSharesApi = new CardSharesApi();
export const cardsApi = new CardsApi();
export const customerPaymentsApi = new CustomerPaymentsApi();
export const ibanApi = new IBANApi();
export const ordersApi = new OrdersApi();
export const paymentApi = new PaymentsApi();
export const transactionsApi = new TransactionsApi();
export const commonTermsApi = new CommonTermsApi();
export const webhookApi = new WebhookApi();
export const configApi = new ConfigApi();
export const clientAPIKeyApi = new ClientAPIKeyApi();
export const usersApi = new UsersApi();
export const rolesApi = new RolesApi();
export const onboardingApi = new OnboardingApi();
